import React from "react";
import { isLoading, Loading } from "../Loading";
import { AppState } from "../system/AppState";
import {
  CaregiverTrainingCenterBundles,
  TrainingCenterCaregiverBundle,
} from "../system/AppState/AppStateTrainingCenter";
import { flmap } from "../utils/fmap";
import { List } from "../utils/List";

function getNumNewVideos(bundles: List<TrainingCenterCaregiverBundle>): number {
  let count = 0;

  for (const bundle of bundles) {
    if (bundle.completionCertificate === null) {
      for (const bundleItem of bundle.bundleItems) {
        if (!bundleItem.itemCompleted && !bundleItem.itemExempt) {
          count += 1;
        }
      }
    }
  }

  return count;
}

const useTrainingCenterState = (appState: AppState) => {
  const [state, setState] = React.useState<
    | Loading
    | {
        bundles: CaregiverTrainingCenterBundles;
        newVideos: number;
      }
  >(
    flmap(appState.appTrainingCenterState, (trainingCenterState) => ({
      bundles: trainingCenterState,
      newVideos: getNumNewVideos(trainingCenterState.bundles),
    }))
  );

  React.useEffect(() => {
    const trainingCenterUpdateBinding = appState.onTrainingCenterUpdated.register(() => {
      if (!isLoading(appState.appTrainingCenterState)) {
        setState({
          bundles: appState.appTrainingCenterState,
          newVideos: getNumNewVideos(appState.appTrainingCenterState.bundles),
        });
      }
    });

    return () => {
      trainingCenterUpdateBinding.unregister();
    };
  }, [appState.appTrainingCenterState, appState.onTrainingCenterUpdated]);

  return state;
};

export default useTrainingCenterState;
